import React from 'react';
import cn from 'classnames';

import ModalDeleteProduct from 'components/stock/ModalDeleteProduct.component';
import TooltipForReceptionist from 'components/TooltipForReceptionist';
import IN from 'constants/in';
import { withTranslation } from 'providers/GILT.provider';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import updateIntercomElement from 'utils/dom/updateIntercomElement.util';

import InputFieldContainer from 'onboarding/common/InputField';

export class EditManufacturerProduct extends React.Component {
  static defaultProps = {
    isSaving: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      saveTitle: '',
      errors: { units_in_stock: false, price: false, cost_price: false },
      filterB: this.props.selectedData ? this.props.selectedData.brand : '',
      filterSub: this.props.selectedData ? this.props.selectedData.sub_brand : '',
      filterCat: this.props.selectedData ? this.props.selectedData.category_name : '',
      listBrand: false,
      listSubBrand: false,
      listCategory: false,
      saveSubBrand: false,
      saveBrand: false,
      saveCategory: false,
      deleteProductModal: false,
    };
  }

  UNSAFE_componentWillMount() {
    updateIntercomElement({ show: false, tag: 'EditManufacturerProduct.UNSAFE_componentWillMount()' });
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.isSaving && !nextProps.isSaving) {
      this.props.onClose();
    }
  }

  componentWillUnmount() {
    updateIntercomElement({ show: true, tag: 'EditManufacturerProduct.componentWillUnmount()' });
  }

  onSaveProductChanges = () => {
    const editItem = this.props.selectedData;
    if (this.state.saveTitle !== '') {
      editItem.title = this.state.saveTitle;
    }

    editItem.brand = this.state.filterB;
    editItem.sub_brand = this.state.filterSub;
    editItem.category_name = this.state.filterCat;

    this.props.onSave(editItem);
  };
  onClose = () => {
    this.setState({
      deleteProductModal: false,
    });
  };
  onDelete = () => {
    if (!this.props.isSaving) {
      this.props.attemptDelete(this.props.selectedData.id);
    }
  };
  validateNumberBlur = (prop, v) => {
    const { errors } = this.state;
    if (
      // if it is units we don't allow empty strings
      (prop === 'units_in_stock' && Number(v)) ||
      // if it is a price or cost price we allow empty strings but if it is not an empty string it must be a number
      ((prop === 'cost_price' || prop === 'price') && Number(v) && v !== '')
    ) {
      errors[prop] = true;
      this.setState({ errors });
      return this.props.t('stocks.managerLayout.sidebarProductProfile.numberValidationError');
    }
    errors[prop] = false;
    this.setState({ errors });
    return '';
  };
  selectBrand = (item) => {
    this.setState({
      filterB: item,
      listBrand: false,
    });
  };
  searchBrand = (event) => {
    this.setState({ filterB: event.target.value, listBrand: true });
  };
  // sub brand
  selectSubBrand = (item) => {
    this.setState({
      filterSub: item,
      listSubBrand: false,
    });
  };
  searchSubBrand = (event) => {
    this.setState({ filterSub: event.target.value, listSubBrand: true });
  };
  searchCategory = (event) => {
    this.setState({ filterCat: event.target.value, listCategory: true });
  };
  selectCategory = (item) => {
    this.setState({
      filterCat: item,
      listCategory: false,
    });
  };

  render() {
    const { filterB, filterSub, filterCat, deleteProductModal } = this.state;
    const { t } = this.props;
    // brands
    const lowercasedFilter = filterB ? filterB.toLowerCase() : '';
    const predicate = (item) =>
      item
        .trim()
        .normalize('NFD')
        .replace(/^0+/, '')
        .replace(/’/, '')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[\u00E9]/g, '')
        .toLowerCase()
        .includes(lowercasedFilter);
    const filteredData = this.props.brandList.filter(predicate);

    // sub brands
    const lowercasedFilterSub = filterSub ? filterSub.toLowerCase() : '';
    const filteredDataSub = this.props.subBrandList.filter((item) => item.toLowerCase().includes(lowercasedFilterSub));
    const lowercaseFiltereCat = filterCat ? filterCat.toLowerCase() : '';
    const filteredDataCat = this.props.categoryList.filter((item) => item.toLowerCase().includes(lowercaseFiltereCat));
    const btnDisabled = this.props.isSaving;

    const buttonClasses = cn({
      'btn btn-violet': true,
      disabled: btnDisabled,
    });

    return (
      <div>
        <div className="product-sidebar">
          <div className="sidebar-header stock">
            {t('stocks.managerLayout.sidebarProductProfile.title')}
            <div role="button" tabIndex={0} className="close-button ico-close" onClick={this.props.onClose} />
          </div>
          <div className="sidebar-content product-profile">
            <section key={this.props.selectedData.id}>
              <div className="cfix relative InputFieldContainer">
                <InputFieldContainer
                  data={{
                    id: `${this.props.selectedData.id.toString()}_name`,
                    label: t('stocks.managerLayout.sidebarProductProfile.productName'),
                    type: 'text',
                    placeholder: t('stocks.managerLayout.sidebarProductProfile.productName'),
                    inputValue: `${this.state.saveTitle ? this.state.saveTitle : this.props.selectedData.title}`,
                    inputMode: 'text',
                  }}
                  onBlurHandler={(value) => {
                    this.setState({ saveTitle: value });
                  }}
                />
                <TooltipForReceptionist where={IN.stockCb} />
              </div>
              <div className="cfix relative search-filter">
                <label htmlFor="brand-dropdown">{t('stocks.managerLayout.sidebarProductProfile.brand')}</label>
                <input
                  value={filterB || ''}
                  onBlur={() => {
                    this.setState({ saveBrand: false });
                  }}
                  onClick={() => {
                    this.setState({ listSubBrand: false });
                  }}
                  onChange={this.searchBrand}
                  type="text"
                  className="input-default"
                  placeholder={t('stocks.managerLayout.sidebarProductProfile.searchBrandsPlaceholder')}
                />
                {this.state.listBrand === true && this.state.filterB.length > 0 && (
                  <div className="dropdown-suggestions">
                    {filteredData.length === 0 && !this.state.saveBrand && (
                      <div className="btn-add-new-brand" key="btn-add-key" role="button" tabIndex="0" onClick={() => this.setState({ saveBrand: true })}>
                        {t('stocks.managerLayout.sidebarProductProfile.asNewBrandButton')}
                      </div>
                    )}
                    {filteredData.map((item) => (
                      <div className="item" key={item} onClick={() => this.selectBrand(item)} role="menuitem" tabIndex="0">
                        <div>{item}</div>
                      </div>
                    ))}
                  </div>
                )}
                <TooltipForReceptionist where={IN.stockCb} />
              </div>
              <div className="cfix relative search-filter">
                <label htmlFor="category">{t('stocks.managerLayout.sidebarProductProfile.subBrand')}</label>

                <input
                  value={filterSub || ''}
                  onBlur={() => this.setState({ saveSubBrand: false })}
                  onClick={() => {
                    this.setState({ listBrand: false });
                  }}
                  onChange={this.searchSubBrand}
                  type="text"
                  className="input-default"
                  placeholder={t('stocks.managerLayout.sidebarProductProfile.subBrandPlaceholder')}
                />
                {this.state.listSubBrand === true && this.state.filterSub.length > 0 && (
                  <div className="dropdown-suggestions">
                    {filteredDataSub.length === 0 && !this.state.saveSubBrand && (
                      <div className="btn-add-new-brand" key="btn-add-key" role="button" tabIndex="0" onClick={() => this.setState({ saveSubBrand: true })}>
                        {t('stocks.managerLayout.sidebarProductProfile.asNewSubBrandButton')}
                      </div>
                    )}
                    {filteredDataSub.map((item) => (
                      <div className="item" key={item} onClick={() => this.selectSubBrand(item)} role="menuitem" tabIndex="0">
                        <div>{item}</div>
                      </div>
                    ))}
                  </div>
                )}
                <TooltipForReceptionist where={IN.stockCb} />
              </div>
              <div className="cfix relative search-filter">
                <label htmlFor="category">{t('stocks.managerLayout.sidebarProductProfile.category')}</label>

                <input
                  value={filterCat || ''}
                  onBlur={() => this.setState({ saveCategory: false })}
                  onClick={() => {
                    this.setState({ listBrand: false });
                  }}
                  onChange={this.searchCategory}
                  type="text"
                  className="input-default"
                  placeholder={t('stocks.managerLayout.sidebarProductProfile.categoryPlaceholder')}
                />
                {this.state.listCategory === true && this.state.filterCat.length > 0 && (
                  <div className="dropdown-suggestions">
                    {filteredDataCat.length === 0 && !this.state.saveCategory && (
                      <div className="btn-add-new-brand" key="btn-add-key" role="button" tabIndex="0" onClick={() => this.setState({ saveCategory: true })}>
                        {t('stocks.managerLayout.sidebarProductProfile.asNewCategoryButton')}
                      </div>
                    )}
                    {filteredDataCat.map((item) => (
                      <div className="item" key={item} onClick={() => this.selectCategory(item)} role="menuitem" tabIndex="0">
                        <div>{item}</div>
                      </div>
                    ))}
                  </div>
                )}
                <TooltipForReceptionist where={IN.stockCb} />
              </div>
              <div className="width-half">
                <InputFieldContainer
                  data={{
                    id: `${this.props.selectedData.id.toString()}_sku`,
                    label: t('stocks.managerLayout.sidebarProductProfile.sku'),
                    type: 'text',
                    placeholder: t('stocks.managerLayout.sidebarProductProfile.sku'),
                    inputValue: `${this.props.selectedData.barcode || ''}`,
                    inputMode: 'text',
                  }}
                  readOnly
                />
              </div>
            </section>
          </div>
          <footer className="product-sidebar-footer product-profile">
            <div className="cfix relative">
              <button
                className="btn btn-violet-link"
                role="menuitem"
                tabIndex={0}
                onClick={() => {
                  this.setState({ deleteProductModal: true });
                }}
              >
                {t('common.buttons.deleteUpp')}
              </button>
              <TooltipForReceptionist where={IN.stockFooter} />
            </div>
            <div className="cfix relative">
              <button onClick={() => void this.onSaveProductChanges()} disabled={btnDisabled} className={buttonClasses}>
                {t('common.buttons.save')}
              </button>
              <TooltipForReceptionist where={IN.stockFooter} />
            </div>
          </footer>
        </div>
        {fromAnyToBool(deleteProductModal) && (
          <ModalDeleteProduct
            icon="alert"
            title={t('stocks.managerLayout.deleteProductModal.title1')}
            message={t('stocks.managerLayout.deleteProductModal.description1')}
            onClose={this.onClose}
            onConfirm={this.onDelete}
          />
        )}
      </div>
    );
  }
}

const EditManufacturerProductHoc = withTranslation()(EditManufacturerProduct);

export default EditManufacturerProductHoc;
